export default __webpack_public_path__ + "63e83c2ad72ff8bd4a41a34a05fdb3b6.png";